<template>
  <div
  id="firstDivSpecifikation"
    class="modal-card"
    style="width: auto; max-height: calc(100vh - 52px)"
  >
    <header class="modal-card-head">
      <!-- <div class="level" style="width: 100%"> -->
      <!-- <div class="level-left">
          <img src="../assets/kalls-logo-v2.svg" width="168">
        </div>
        <div class="level-right"> -->
      <p class="modal-card-title">
        Artikelspecifikation
      </p>
      <!-- </div> -->
      <!-- </div> -->
    </header>
    <section class="modal-card-body">
      <b-table :data="articles">
        <template slot-scope="props">
          <b-table-column
            field="articleNumber"
            label="Artnr"
            id="artnr"
            
          >
            {{ props.row.displayId }}
          </b-table-column>

          <b-table-column
            field="articleName"
            label="Artikelnamn"
          >
            {{ props.row.articleName }}
          </b-table-column>

          <b-table-column
            field="quantity"
            label="Antal"
            numeric
          >
            {{ props.row.quantity }}
          </b-table-column>

          <b-table-column
            field="price"
            label="Pris/st"
            numeric
          >
            {{ formatter.format(props.row.price) }} kr
          </b-table-column>

          <b-table-column
            field="total"
            label="Total"
            numeric
          >
            {{ formatter.format(props.row.total) }} kr
          </b-table-column>

          <b-table-column
            field="onlyQuote"
            label=""
          >
            {{ props.row.onlyQuote }}
          </b-table-column>
        </template>
      </b-table>

      <b-field
      id="varningOverloadText"
          v-show="sectorOverload"
      >
      
                          <b-icon
                             
                              style="margin-left: 1em;"
                              icon="exclamation-triangle"
                              id="exclamation-triangle-small"
                              
                          />
                      
        <p
            class="textControll overloadWarningSpecText"
            ><bold>
          Max kapacitet har överstigits! Välj gavlar med en högre kapacitet, eller välj bärbalkar med en lägre kapacitet.
        </bold>
        </p>


      </b-field>

      <div class="totalArticleWrapper">
        <div class="totalSumWrapper"
        >
          <span >SUMMA ARTIKLAR</span>
          {{ formatter.format(totalSum) }} kr
        </div>
        <div class="priceInfoWrapper">
          <div
          class="divPriceExVat"
          >
          (exkl. moms)
          </div>
          <div class="reservationPrice"
          style="font-weight: 100; text-align: end; padding-right: 38px; font-size: 0.85em"
          >
          Med reservation att priser kan skilja sig från webbutikens priser.
          Webbutikens priser gäller.
          </div>
        </div>
          <div class="bottomSpecWrapper">
            <div class="pdfWrapper">
              <a class="aIcon" href="#"><img src="../assets/download-pdf.svg" alt="Ladda ner pdf"></a>
              <a class="aText" href="#">Ladda ned pdf</a>
            </div>
            <button
              title="Lägg i varukorgen"
              class="button level-item is-large buy-btn"
              style=""
              @click="addToCart"
            >
              Lägg i varukorg
            </button>
            
          </div>
      </div>
      <!-- END TOTAL ARTICLE WRAPPER-->

      <!-- FOOTER IS SET NO HIDDEN-->
      <div
        v-if="showLink"
        class="showLinkToStore"
        style="margin: 1em 0; font-weight: 600"

      >
        Om du inte automatiskt kommer till webbshoppen,
        <a
          type="button is-primary"
          href="https://kalls.se/produkter/forvaring/lagerinredning/pallstall/"
          target="_blank"
        >klicka här
          <b-icon
            icon="external-link-alt"
            size="is-small"
            style="vertical-align: sub"
          /></a>.
      </div>
    </section>
    <footer class="modal-card-foot">
      <nav
        class="level"
        style="width: 100%"
      >
        <div class="level-left">
          <div class="level-item">
            <button
              class="button level-item"
              type="button"
              @click="$parent.close()"
            >
              Tillbaka
            </button>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <button
              class="button level-item is-large"
              style="background-color: #128C0C; color: white; font-weight: 600"
              @click="addToCart"
            >
              KÖP
            </button>
          </div>
        </div>
      </nav>
      <div
        class="is-hidden-tablet"
        style="height: 1em"
      />
    </footer>

    <b-loading
      :active.sync="loaded >= 0 && loaded < cart.length"
      :can-cancel="true"
    />

    <div style="display: none">
      <iframe
        v-for="item in cart"
        :key="item"
        :src="item"
        frameborder="0"
        @load="loaded += 1"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import serverInfo from './../serverinfo/';
import $ from "jquery";

const SERVER_BASE_URL = serverInfo.SERVER_BASE;
const API_URL         = serverInfo.API_URL;

export default {
  data() {
    return {
      cart: [],
      loaded: -1,
      showLink: false
    };
  },
  computed: {
    ...mapState([
      "selectedUprights",
      "selectedHeight",
      "sectors",
      "sectorOverload",
      "includeRackGuards",
      "assembledUprights",
      "includeUprightProtectors",
      "includeImpactProtectors",
    ]),
    ...mapGetters([
      "selectedUpright",
      "distances",
      "uprightProtectors",
      "impactProtectors",
      "rackGuards"
    ]),

    totalSum() {
      let calcSum = (sum, a) => {
        return sum + Math.round(a.total);
      };

      return this.articles.reduce(calcSum, 0);
    },

    formatter() {
      return new Intl.NumberFormat("sv-SE", {
         style: "decimal",
       // style: "currency",
        currency: "SEK",
        currencyDisplay: "symbol"
      });
    },

    articles() {
      const products = new Map();

      const addProduct = (key, item, addQuantity, addTotal) => {
        if (products.has(key)) {
          products.get(key).quantity += addQuantity;
          products.get(key).total += addTotal;
        } else {
          products.set(key, item);
        }
      };

      let doubleRack = this.$store.state.doubleRack;
      let variant = this.selectedUpright.variants.find(
        v => v.assembled === this.assembledUprights
      );

      let selectedUprights = this.$store.state.selectedUprights;
      let selectedUprightName = selectedUprights.name;

      this.sectors.forEach(sector => {
        let quantity = Number(sector.sectionCount) * (doubleRack ? 2 : 1);
        let variantQty = quantity + (doubleRack ? 2 : 1);
        addProduct(variant.artNo, {
          articleNumber: variant.artNo,
          articleName: variant.name,
          displayId: variant.displayid,
          quantity: variantQty,
          price: variant.price,
          total: variant.price * variantQty,
        }, quantity, variant.price * quantity);
      });

      this.sectors.forEach(sector => {
        let quantity = Number(sector.levelCount) * Number(sector.sectionCount) * (doubleRack ? 2 : 1) * 2;
        addProduct(sector.beam.artNo, {
          articleNumber: sector.beam.artNo,
          displayId: sector.beam.displayid,
          articleName: "Pallställ bärbalk City " + sector.beam.length + " mm " + sector.beam.pallets + "x" + sector.beam.loadCapacity + " kg",
          quantity: quantity,
          price: sector.beam.price,
          total: sector.beam.price * quantity,
        }, quantity, sector.beam.price * quantity);

        if (this.includeRackGuards) {
          let rackGuard = this.rackGuards
            .filter(rg => rg.pallets == sector.beam.pallets && rg.minBeamLength && sector.beam.length >= rg.minBeamLength)
            .sort((a, b) => b.minBeamLength - a.minBeamLength)[0]
            || this.rackGuards.find(rg => rg.pallets == sector.beam.pallets && !rg.minBeamLength);
          let rackQty = Number(sector.levelCount) * Number(sector.sectionCount);
          addProduct(rackGuard.artNo, {
            articleNumber: rackGuard.artNo,
            displayId: rackGuard.displayid,
            articleName: rackGuard.name,
            quantity: rackQty,
            price: rackGuard.price,
            total: rackGuard.price * rackQty,
          }, rackQty, rackGuard.price * rackQty);
        }

        if (this.includeUprightProtectors) {
          // We use a different article here if an 18 ton gable is selected
          let index = (selectedUprightName == 18) ? 1 : 0;
          let uprightProtectors = this.uprightProtectors[index];
          let upQty = Number(sector.sectionCount) * (doubleRack ? 2 : 1);
          let upInitQty = upQty + (doubleRack ? 2 : 1);
          addProduct(uprightProtectors.artNo, {
            articleNumber: uprightProtectors.artNo,
            displayId: uprightProtectors.displayid,
            articleName: uprightProtectors.name,
            quantity: upInitQty,
            price: uprightProtectors.price,
            total: uprightProtectors.price * upInitQty,
          }, upQty, uprightProtectors.price * upQty);
        }

        if (this.includeImpactProtectors) {
          let impactProtectors = this.impactProtectors[doubleRack ? 1 : 0];
          addProduct(impactProtectors.artNo, {
            articleNumber: impactProtectors.artNo,
            displayId: impactProtectors.displayid,
            articleName: impactProtectors.name,
            quantity: 2,
            price: impactProtectors.price,
            total: impactProtectors.price * 2,
          }, 1, impactProtectors.price);
        }

        if (doubleRack) {
          let distance = this.distances[0];
          let distQty = Number(sector.sectionCount) * 2;
          let distInitQty = distQty + 2;
          addProduct(distance.artNo, {
            articleNumber: distance.artNo,
            displayId: distance.displayid,
            articleName: distance.name,
            quantity: distInitQty,
            price: distance.price,
            total: distance.price * distInitQty,
          }, distQty, distance.price * distQty);
        }
      });

      return Array.from(products.values());
    },
    columns() {
      return [
        {
          field: "articleNumber",
          label: "Artikelnummer"
        },
        {
          field: "articleName",
          label: "Artikelnamn"
        },
        {
          field: "quantity",
          label: "Antal"
        },
        {
          field: "price",
          label: "Pris"
        },
        {
          field: "total",
          label: "Total"
        },
        {
          field: "onlyQuote",
          label: ""
        }
      ];
    }
  },
  methods: {
    async addToCart() {
      this.loaded = 0;
      this.cart = [];

      console.log("initPurchase started!");

      // Build rows to add
      var itemArgs = [];

      this.articles.forEach( article => {
        itemArgs.push({
          "prodno": parseInt( article.articleNumber ),  // Note Using articleNumber instead of artNo is intentional :)
          "quantity": parseInt( article.quantity )
        });
      });

      console.log( "itemArgs:" );
      console.log( itemArgs );

      var args = {
        "items": itemArgs,
      }

      var showErrorMessage = this.showErrorMessage;
      var submitPurchase = this.submitPurchase;

      $.ajax({
        "url": SERVER_BASE_URL+"?cmd=sign_purchase",
        "data": JSON.stringify(args),
        "method": "POST",
        "dataType": "json",
        /* eslint-disable-next-line */ // Added comment to avoid warnings because textStatus and xhr aren't used :)
        "success": function (data, textStatus, xhr) {
          if (data.status !== "OK")
            showErrorMessage( "Serverfel, kunde ej lägga till varorna i varukorgen, prova igen senare." );
          else
            submitPurchase(data.signature, data.script);
        },
        // eslint-disable-next-line no-unused-vars
        "error": function(qXHR, textStatus, errorThrown) {
          showErrorMessage("Serverfel, kunde ej lägga till varorna i varukorgen, prova igen senare.");
        }
      });
    },

    async submitPurchase( signature, script )
    {
      console.log("submitPurchase started!");

      // TODO verify if these declarations are needed
      this.cart = null;
      this.loaded = -1;
      this.showLink = true;

      var showErrorMessage = this.showErrorMessage;

      $.ajax({
        "url": API_URL,
        "headers": {
          "X-API-Signature": signature,
          "Content-Type": "application/json"
        },
        "data": JSON.stringify( script ),
        "method": "POST",
        "dataType": "json",
        "xhrFields": {
          "withCredentials": true
        },
        "success": function( data, textStatus, xhr ) {
          var lastResponse = data.response.pop();

          if( lastResponse && lastResponse.location )
            window.location.href = lastResponse.location;
          else
            showErrorMessage("Serverfel, kunde ej lägga till varorna i varukorgen, prova igen senare.");
        },
        // eslint-disable-next-line no-unused-vars
        "error": function(qXHR, textStatus, errorThrown) {
          showErrorMessage("Serverfel, kunde ej lägga till varorna i varukorgen, prova igen senare.");
        }
      });
    },

    async showErrorMessage( msg )
    {
      alert( msg );
    }
  }
};
</script>
